import { render } from "./IconBarcodeLink.vue?vue&type=template&id=b7f57b24"
import script from "./IconBarcodeLink.vue?vue&type=script&lang=ts"
export * from "./IconBarcodeLink.vue?vue&type=script&lang=ts"
script.render = render

export default script